import { render, staticRenderFns } from "./multitenancy.vue?vue&type=template&id=761936fe&"
import script from "./multitenancy.vue?vue&type=script&lang=js&"
export * from "./multitenancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports